import { print } from "graphql";
import { Client } from "graphql-ws";
import { getActiveMenuQueryKey } from "./use-get-active-menu";
import { getActiveMenuCategoriesQueryKey } from "./use-get-active-menu-categories";
import { getCurrentLocationQueryKey } from "./use-get-current-location";
import { getCurrentVenueQueryKey } from "./use-get-current-venue";
import { LocationSubscriptionSummaryFragment } from "./fragments/location-subscription-summary";
import { reconcileCartForRealtimeContext } from "~/libs/realtime";
import {
	GetCurrentLocationQuery,
	GetCurrentVenueQuery,
	SubscribeToLocationDocument,
	SubscribeToLocationSubscription,
} from "~/types/__generated/gql/graphql";
import { queryClient } from "~/providers/query-provider";

void (
	/* GraphQL */ `
		subscription SubscribeToLocation($id: ObjectID!) {
			subscribeToLocation(id: $id) {
				type
				id
				payload {
					...LocationSubscriptionSummary
				}
			}
		}
		${LocationSubscriptionSummaryFragment}
	`
);

export const subscribeToLocation = (client: Client, locationId: string) =>
	client.subscribe<SubscribeToLocationSubscription>(
		{
			query: print(SubscribeToLocationDocument),
			variables: { id: locationId },
		},
		{
			next: async (result) => {
				const event = result.data?.subscribeToLocation;
				if (event?.type === "delete" || !event?.payload) return;

				const locationQueryKey = getCurrentLocationQueryKey();
				const venueQueryKey = getCurrentVenueQueryKey();
				const prevLocation =
					queryClient.getQueryData<GqlResultOf<GetCurrentLocationQuery>>(
						locationQueryKey,
					);
				const prevVenue =
					queryClient.getQueryData<GqlResultOf<GetCurrentVenueQuery>>(
						venueQueryKey,
					);

				await Promise.all([
					queryClient.invalidateQueries({
						queryKey: locationQueryKey,
						exact: true,
					}),
					queryClient.invalidateQueries({
						queryKey: getActiveMenuQueryKey(),
						exact: true,
					}),
					queryClient.invalidateQueries({
						queryKey: getActiveMenuCategoriesQueryKey(),
						exact: true,
					}),
					queryClient.invalidateQueries({
						queryKey: ["getActiveMenuItemsQr"],
					}),
					queryClient.invalidateQueries({
						queryKey: ["getActiveMenuItem"],
					}),
				]);

				reconcileCartForRealtimeContext({
					prevVenue,
					nextVenue: prevVenue,
					prevLocation,
					nextLocation: event.payload,
				});
			},
			error: (error) => console.error(error),
			complete: () => undefined,
		},
	);
